<template>
  <v-app color="primary">
    <v-main v-if="desktop && !from">
      <!-- Top Swiset Pro CTA !-->
      <TopProCTA
        v-if="this.upgradeExceptionRoutes.indexOf($route.name) === -1 && !this.$store.state.user.isPro && !isEmbedded" />
      <!-- Main App Views !-->
      <TopNavbar v-if="isEmbedded && this.outOfAppExceptionRoutes.indexOf($route.name) === -1" />
      <v-row
        :style="!isEmbedded && (this.fullHeightRoutes.indexOf($route.name) === -1) ? '' : 'height: 100% !important;'">
        <v-col v-if="!isEmbedded && this.outOfAppExceptionRoutes.indexOf($route.name) === -1" cols="1">
          <Navbar class="mr-n10" />
        </v-col>
        <v-col :class="!isEmbedded && (this.outOfAppExceptionRoutes.indexOf($route.name) === -1) ? 'ml-n10 pr-1' : 'pa-0'"
          :cols="!isEmbedded && (this.outOfAppExceptionRoutes.indexOf($route.name) === -1) ? '11' : '12'">
          <v-spacer v-if="isEmbedded" class="my-10" />
          <RouterView :class="isEmbedded ? 'px-10' : ''" />
          <PoweredBy v-if="isEmbedded && showPowered" id="powered-by-fixed" />
        </v-col>
      </v-row>

      <!-- Help & Support Components !-->
      <HelpDesk :help="helpDesk" @close="helpDesk = false" />
      <v-btn v-if="this.upgradeExceptionRoutes.indexOf($route.name) === -1"
        :class="($store.state.user.isPro) ? 'help-button-for-pro' : 'help-button-no-pro'" @click="helpDesk = !helpDesk"
        dark top right color="secondary" small>
        <p style="font-size: 14px;" class="my-0">{{ $t('btnHelp') }}</p> <v-icon class="ml-2"
          color="#00F784" x-small>fa-question</v-icon>
      </v-btn>
    </v-main>
    <v-main v-else-if="!desktop && !from">
      <MobileNote />
    </v-main>
    <v-main v-if="from == 'verified'">
      <MagicLinkConfirmation />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar";
import TopProCTA from "./components/TopProCTA.vue";
import axios from 'axios';
import { mapMutations, mapActions } from 'vuex';
import MobileNote from "./MobileNote";
import HelpDesk from "@/components/HelpDesk";
import TopNavbar from "@/components/TopNavbar.vue";
import PoweredBy from "@/components/PoweredBy.vue";
import MagicLinkConfirmation from "./components/MagicLinkConfirmation.vue";

export default {
  name: 'App',
  components: {
    PoweredBy,
    TopNavbar,
    HelpDesk,
    MobileNote,
    Navbar,
    TopProCTA,
    MagicLinkConfirmation
  },
  data() {
    return {
      logged: false,
      fullHeightRoutes: [
        'login',
        'onboard',
      ],
      upgradeExceptionRoutes: [
        'login',
        'subscription-plans',
        'welcome',
        'register-collapsed',
        'subscription-plans-collapsed',
        'confirmed-email',
        'reset-password',
        'basic-data',
        'confirmation',
        'sync-authorization',
        'sync-authorization-request',
        'tournament-embed-rank',
        'embed',
        'embed-introduction',
        'passwordless-checking',
        'embed-sso',
        'onboard',
      ],
      outOfAppExceptionRoutes: [
        'login',
        'welcome',
        'register-collapsed',
        'subscription-plans-collapsed',
        'basic-data',
        'reset-password',
        'confirmed-email',
        'sync-authorization',
        'sync-authorization-request',
        'tournament-embed-rank',
        'embed',
        'embed-introduction',
        'passwordless-checking',
        'embed-sso',
        'onboard'
      ],
      desktop: true,
      hydrated: false,
      helpDesk: false,
    };
  },
  created() {
    //get themes service callback
    //this.$vuetify.theme.dark = false
    if (this.$store.state.whitelabel.partner == null) {
      let obj =
        { "light": { "baseBackground": "#F8F8F8", "navBarBackground": "#061130", "mainBtnBackground": "#C3FFE3", "alternativeBtnBackground": "#dcdcdc", "brandPrimary": "#00a553", "brandSecondary": "#061130", "brandAccent": "#007CFF", "warningAdvice": "#FF8933", "mainWhite": "#F9F9F9", "mainBlack": "#000000", "darkGrey": "#4E4E4E", "mediumGrey": "#EFEFEF", "lightGrey": "#DCDCDC", "darkGreen": "#00a553", "calmGreen": "#C3FFE3", "darkRed": "#C42A14", "calmRed": "#FFCAC2", "darkBlue": "#1B5BFF", "calmBlue": "#93C7FF" }, "dark": { "baseBackground": "#1B1B1B", "navBarBackground": "#DCDCDC", "mainBtnBackground": "#C3FFE3", "alternativeBtnBackground": "#4E4E4E", "brandPrimary": "#0044A9", "brandSecondary": "#061130", "brandAccent": "#007CFF", "warningAdvice": "#FF8933", "mainWhite": "#000000", "mainBlack": "#F9F9F9", "darkGrey": "#DCDCDC", "mediumGrey": "#EFEFEF", "lightGrey": "#4E4E4E", "darkGreen": "#C3FFE3", "calmGreen": "#247851", "darkRed": "#FFCAC2", "calmRed": "#C42A14", "darkBlue": "#93C7FF", "calmBlue": "#1B5BFF" } }
      this.updateAppThemes(obj)
    }

    let darkMode = new URLSearchParams(window.location.search).get("darkMode");
    if (darkMode == false || darkMode == "false") {
      this.$vuetify.theme.dark = false;
      this.setCurrentTheme("light");
    } else if (darkMode || this.$store.state.currentTheme == "dark") {
      this.$vuetify.theme.dark = true;
      this.setCurrentTheme("dark");
    }

  },
  computed: {
    from() {
      return this.$route.query.from;
    },
    isEmbedded() {
      return this.$store.state.whitelabel.partner !== null;
    },
    showPowered() {
      // eslint-disable-next-line no-console
      if (this.$route.name != "onboard" && !this.$route.name.includes("embed")) {
        return true;
      }
      return false;
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.helpDesk = false;
    },
    '$store.state.user.isPro': function () {
      this.verifyPremiumChat();
    },
    '$store.state.preferredLanguage': function () {
      this.$root.$i18n.locale = this.$store.state.preferredLanguage;
    },
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      this.verifyPremiumChat();
      this.verifyPreferredLanguage();
      this.verifyIfDesktop();
      this.verifyLogged();
      this.loadBasicData();
      await this.$apollo.provider.defaultClient.hydrated();
      this.hydrated = true;

    },
    verifyPremiumChat() {
      if (this.$store.state.user.isPro) {
        let freshChatScript = document.createElement('script');
        freshChatScript.setAttribute('src', '//fw-cdn.com/8252205/3311251.js');
        freshChatScript.setAttribute('chat', 'true');
        document.head.appendChild(freshChatScript);
        window.fcWidget.user.setFirstName(this.$store.state.user.firstName);
        window.fcWidget.user.setEmail(this.$store.state.user.email);
        window.fcWidget.setExternalId(this.$store.state.user.id);
      }
    },
    verifyPreferredLanguage() {
      if (this.$store.state.preferredLanguage !== '')
        this.$root.$i18n.locale = this.$store.state.preferredLanguage;
    },
    verifyIfDesktop() {
      if (this.$route.name === 'sync-authorization')
        this.desktop = true;
      else
        this.desktop = (screen.width >= 760);
    },
    verifyLogged() {
      this.logged = (this.$store.state.token !== '');
      if (this.logged && ['login', 'embed'].includes(this.$route.name))
        this.$router.push('/dashboard');
    },
    ...mapActions([
      "updateAppThemes",
    ]),
    ...mapMutations(['setMarkets', 'setIsPro', "setCurrentTheme"]),
    loadBasicData() {
      axios.get(`${this.$store.state.backend}/markets`).then(
        (response) => {
          //this.setMarkets(response.data.map(a => a.name));
          this.setMarkets(response.data);
        });
      if (this.$store.state.token !== '') {
        axios.get(`${this.$store.state.backend}/ext/user-details/user/pro`,
          { headers: { 'Authorization': this.$store.state.token } }).then(
            (response) => {
              if (response.status < 400 && response.data) {
                this.setIsPro(true);
              }
            });
      }
    },
  }
};
</script>

<i18n>
{
  "en": {
    "btnHelp" : "Need Help"
  },
  "es": {
    "btnHelp" : "Necesita ayuda"
  }
}
</i18n>

<style lang="scss">
@import "global";

@font-face {
  font-family: 'Product Sans';
  font-style: normal;
  font-weight: normal;
  src: url('./assets/fonts/ProductSans-Regular.woff') format('woff');
}

@font-face {
  font-family: 'Product Sans';
  font-style: normal;
  font-weight: bold;
  src: url('./assets/fonts/ProductSans-Bold.woff') format('woff');
}

@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: normal;
  src: url('./assets/fonts/Avenir-Book.woff') format('woff');
}

#app {
  font-family: 'Product Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--v-mainBlack-base) !important;
  width: 100vw;
  //height: 100vh;
  height: auto;
  background-color: var(--v-baseBackground-base);

  .v-btn {
    box-shadow: none !important;
    display: flex;
    align-items: center;
    background-color: var(--v-mainBtnBackground-base) !important;
    color: var(--v-mainBlack-base) !important;
    padding: 9px 15px;
    border: 0 !important;
    outline: 0 !important;
    font-size: 16px;
    font-style: normal;
    margin-left: 10px;

  }

  .theme--dark.v-chip {
    background-color: var(--v-mainBlack-base);
    color: var(--v-mainWhite-base);
  }

  .primary--text {
    color: var(--v-brandPrimary-base) !important;
    caret-color: var(--v-brandPrimary-base) !important;
  }


  .v-calendar-monthly,
  .v-calendar-weekly,
  .v-calendar {
    background-color: transparent !important;

    .primary {
      background-color: var(--v-mainBtnBackground-base) !important;
      border: 1px solid var(--v-mainBtnBackground-base) !important;
    }
  }

  .accent {
    background-color: var(--v-mainBtnBackground-base) !important;
    border: var(--v-mainBtnBackground-base) !important;
    ;
  }

  .v-icon {
    color: inherit;
  }

  .apexcharts-toolbar {
    z-index: 1;
  }

  .apexcharts-text {
    fill: var(--v-mainBlack-base);
  }

  .apexcharts-yaxis-annotation-label {
    fill: var(--v-mainWhite-base);
    stroke: var(--v-mainBlack-base);
  }

  .apexcharts-svg {
    background-color: transparent !important;
  }

  .outside-container {
    display: flex;
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: var(--v-baseBackground-base);

    .magic-verified-view {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: auto;

      .title-2 {
        display: flex;
        justify-content: center;
        color: var(--v-mainBlack-base);
        font-size: 30px;
        font-weight: 700;
        font-family: "Product Sans", sans-serif;
      }

      button {
        background-color: var(--v-mainBtnBackground-base) !important;
        color: var(--v-mainBlack-base) !important;

        &:hover {
          background-color: var(--v-brandAccent-base) !important;
        }
      }
    }
  }
}


.theme--dark.v-card {
  color: #ffffff;
}

/* width */
::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #00a553;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#powered-by-fixed {
  margin-top: -100px;
  /*same as height*/
  margin-bottom: 10px;
  /*to avoid going under the bottom:20px we want*/
  position: fixed;
  left: 20px;
  top: calc(100vh - 10px);
}

h1 {
  color: var(--v-mainBlack-base);
  //font: 40px $title-font;
  font: 40px 'Product Sans';
  font-weight: bold;
}

h2 {
  color: var(--v-darkGrey-base);
  font: 32px $title-font;
}

h3 {
  color: var(--v-darkGrey-base);
  font: 17px $title-font;
}

h4 {
  color: var(--v-darkGrey-base);
  font: 16px $title-font;
}

p {
  color: var(--v-mainBlack-base);
}

* {
  font: 15px 'Avenir', sans-serif;
  text-transform: none !important;
}

.green-button {
  border: 1px solid $primary-color !important;
  background-color: $primary-color !important;
  color: $black-color !important;
}

.green-button:hover {
  border: 2px solid $primary-color !important;
  background-color: $primary-color !important;
  color: $black-color !important;

  border-radius: 7px !important;
  font: 16px $title-font;
  padding: 1% 3%;
}

button {
  border: 1px solid $border-color !important;
  border-radius: 7px !important;
  font: 16px $title-font;
  color: var(--v-dark-base) !important;
  padding: 1% 3%;
}

button:hover {
  border: 1px solid $black-color !important;
  background-color: $black-color !important;
  color: var(--v-dark-base) !important;
}

.submit-button {
  padding: 1.5% 5% !important;
  color: $black-color !important;
  border: 0px solid #247851 !important;
  border-radius: 7px !important;
  background-color: $calm-green !important;
  box-shadow: 1px 1px 10px rgba(36, 120, 81, 0.25);
}

.submit-button:hover {
  color: $calm-green !important;
  border: 0px solid #247851 !important;
}

.back-button {
  padding: 1.5% 5% !important;
  color: $black-color !important;
  border: 0px solid white !important;
  border-radius: 7px !important;
  background-color: #DCDCDC !important;
  box-shadow: 1px 1px 10px rgba(36, 120, 81, 0.25);
}

.back-button:hover {
  color: $black-color !important;
  border: 0px solid white !important;
  background-color: #DCDCDC !important;
}

.button-giant {
  padding: 3% 7% !important;
}

table.v-table thead th {
  font-size: 17px !important;
}

table.v-table tbody td {
  font-size: 16px !important;
}

.section-card {
  background-color: rgba(144, 146, 156, 0) !important;
}

.overall-card-collapsed {
  height: 100px !important;
  min-width: 200px !important;
  border-radius: 20px !important;

  .head {
    color: $black-color;
    font-size: 22px;
  }

  .content {
    color: $text-color;
    margin-bottom: 0;
  }
}

.adding-card-collapsed {
  height: 100px !important;
  min-width: 200px !important;
  border: 2px dashed #6C7079 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6C7079;
  }
}

.see-more-card-collapsed {
  height: 100px !important;
  min-width: 200px !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6C7079;
  }
}

.ad-card-collapsed {
  height: 100px !important;
  min-width: 200px !important;
  border: 3px solid $blue-color !important;
  border-radius: 20px !important;
  background-color: #FFFFFF !important;

  .badge {
    font-size: 12px;
    color: #FFFFFF;
    background-color: $blue-color;
    margin-right: -5px;
    padding: 3px 5px 6px;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
  }

  .ad-title {
    font-size: 17px !important;
    color: $black-color !important;
  }

  .ad-description {
    font-size: 14px;
    color: $subtitle-color;
  }

  .ad-btn {
    background-color: $black-color !important;
    color: $white-color !important;
  }

  .ad-btn:hover {
    background-color: $blue-color !important;
    border-color: $blue-color !important;
  }
}

.overall-card {
  height: 160px !important;
  min-width: 200px !important;
  border-radius: 20px !important;

  .head {
    color: $black-color;
    font-size: 23px;
  }

  .content {
    color: $text-color;
  }
}

.adding-card {
  height: 160px !important;
  min-width: 200px !important;
  border: 2px dashed #6C7079 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6C7079;
  }
}

.see-more-card {
  height: 160px !important;
  min-width: 200px !important;
  border: 1px solid #d0d0d0 !important;
  border-radius: 20px !important;
  background-color: rgba(108, 112, 121, 0) !important;

  .plus-icon {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-color: #e6e6e6;
    color: #6C7079;
  }
}

.icon {
  color: #929292 !important;
  border: none !important;
}

.icon:hover {
  color: #929292 !important;
  background-color: rgba(85, 85, 85, 0) !important;
  border: none !important;
}

.help-button {
  display: block;
  border: none;
  position: fixed;
  top: auto;
  bottom: 90% !important;
  right: 0;
  width: 150px;
  height: 350px;
  transform: translateY(50%) rotate(-90deg) !important;
  opacity: 1;
  background: none transparent !important;
  margin: 0 !important;
  padding: 0 !important;
  max-height: 100vh;
  max-width: 100vw;
  transition: none 0s ease 0s !important;
  visibility: visible;
  z-index: 99999 !important;
}

.help-button-for-pro {
  position: fixed;
  right: 0;
  bottom: 50%;
  height: 100px;
  width: 150px !important;
  transform: rotate(-90deg);
  margin: 0 -60px 0 0;
}

.help-button-no-pro {
  position: fixed;
  right: 0;
  bottom: 50%;
  height: 100px;
  width: 150px !important;
  transform: rotate(-90deg);
  margin: 0 -60px 0 0;
}

.row {
  margin-top: 0;
  margin-bottom: 0;
}

.row+.row {
  margin-top: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
